/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/restaurant_medium'
export default icon
